import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { Color } from 'module/ui/components/styles';
import {
  faLightbulbOn,
  faWarning,
  faWrench,
  IconDefinition,
} from '@fortawesome/pro-solid-svg-icons';
import { SignalType } from 'api/signal/types';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const RiskIcon = styled(FontAwesomeIcon)`
  color: var(--red-60);
`;
const OpportunityIcon = styled(FontAwesomeIcon)`
  color: var(--green-60);
`;
const OperationalIcon = styled(FontAwesomeIcon)`
  color: var(--icon-secondary);
`;

type Config = {
  name: React.ReactNode;
  icon: React.ReactNode;
  color: Color;
  colorVariable: string;
  rawIcon: IconDefinition;
};
export const signalTypeConfigs: Record<SignalType, Config> = {
  [SignalType.Risk]: {
    name: <FormattedMessage id="signal_configuration.signal_type.risk.name" />,
    icon: <RiskIcon icon={faWarning} size={12} />,
    rawIcon: faWarning,
    color: 'red',
    colorVariable: 'var(--red-60)',
  },
  [SignalType.Opportunity]: {
    name: (
      <FormattedMessage id="signal_configuration.signal_type.opportunity.name" />
    ),
    icon: <OpportunityIcon icon={faLightbulbOn} size={16} />,
    rawIcon: faLightbulbOn,
    color: 'green',
    colorVariable: 'var(--green-60)',
  },
  [SignalType.Operational]: {
    name: (
      <FormattedMessage id="signal_configuration.signal_type.operational.name" />
    ),
    icon: <OperationalIcon icon={faWrench} size={12} />,
    rawIcon: faWrench,
    color: 'cool-gray',
    colorVariable: 'var(--icon-secondary)',
  },
};
export const signalTypesAsOptions: Array<{
  label: React.ReactNode;
  value: SignalType;
  icon: React.ReactNode;
}> = Object.entries(signalTypeConfigs).map(([key, value]) => ({
  label: value.name,
  value: key as SignalType,
  icon: value.icon,
}));
